import React, { useState } from 'react';
import Select from 'react-select/creatable';
import withStyles from '@material-ui/core/styles/withStyles';

export default ({
  options,
  value,
  classes,
  defaultValue,
  loading,
  searching,
  isMulti,
  onChange,
}) => {
  const handleChange = (newValue, actionMeta) => {
    onChange(newValue);
  };
  return (
    <Select
      isSearchable
      isLoading={searching || loading}
      closeMenuOnSelect={true}
      defaultValue={defaultValue}
      isMulti={isMulti}
      //   onInputChange={handleInputChange}
      onChange={handleChange}
      options={options}
      placeholder={value}
    />
  );
};
